import React from 'react';
import { Button } from 'antd';
import { FallbackProps } from 'react-error-boundary';

import { Layout } from 'shared/components/layout/Layout';
import {
  ErrorFallbackLayout,
  ErrorFallbackContainer,
  ErrorFallbackTitle,
} from './ErrorFallback.styles';

export function ErrorFallback({ error, resetErrorBoundary }: FallbackProps) {
  return (
    <ErrorFallbackLayout>
      <Layout>
        <ErrorFallbackContainer>
          <ErrorFallbackTitle>Something went wrong:</ErrorFallbackTitle>
          <pre>{error.message}</pre>
          <Button onClick={resetErrorBoundary}>Back to Dashboard</Button>
        </ErrorFallbackContainer>
      </Layout>
    </ErrorFallbackLayout>
  );
}
